import React, { useState } from "react";
import stilePulsanti from "../interfaccia/stilePulsanti";
import apiUrl from "../Apiurl";
import RiquadroStatoBeta from "./RiquadroStatoBeta";
import StatiTrasmessiTutti from "./StatiTrasmessiTutti";
import beep from "../../components/files/sounds/beep-6-96243.mp3";
import errorSound from "../../components/files/sounds/error-call-to-attention-129258.mp3";

function AreaLogisticaBeta(props) {
  //TODO
  //PROSSIME EVOLUTIVE:
  // AGGIUNGERE CAMPO DATA A TABELLA STATI
  // INTRODURRE TASTO "RITIRATI DAL CORRIERE" PER OGNI STATO-CORRIERE
  // con dicitura "se un pacco non è stato ritirato, puoi rimuoverlo dalla lista sparandolo in attesa"
  // IL TASTO CAMBIA LO STATO DA "PRONTO PER XXX" A "RITIRATO DA XXX"
  // AL POSTO DELL'ARRAY DEGLI ORDINI TRASMESSI, NEL RIQUADRO DEL CORRIERE FARE DIRETTAMENTE QUERY DEGLI ORDINI IN STATO "PRONTO PER"
  // RIMUOVERE L'INSERIMENTO/RIMOZIONE IN ARRAY DEGLI ORDINI TRASMESSI E AGGIUNGERE LA DATA AI DATI TRASMESSI
  // MOSTRARE DATA TRASMISS. VICINO A ORDINE NEL RIQUADRO

  //const utente = props.utente
  const { inputClassesConTasto } = stilePulsanti;

  const [stati, setStati] = useState([
    {
      nomeRiquadro: "BRT",
      nomeStato: "PRONTO PER BRT",
      coloreRiquadro: "dark-red",
      coloreScritta: "white",
      ordiniTrasmessi: [],
    },
    {
      nomeRiquadro: "GLS",
      nomeStato: "PRONTO PER GLS",
      coloreRiquadro: "dark-blue",
      coloreScritta: "white",
      ordiniTrasmessi: [],
    },
    {
      nomeRiquadro: "DHL",
      nomeStato: "PRONTO PER DHL",
      coloreRiquadro: "gold",
      coloreScritta: "black",
      ordiniTrasmessi: [],
    },
    {
      nomeRiquadro: "UPS",
      nomeStato: "PRONTO PER UPS",
      coloreRiquadro: "dark-pink",
      coloreScritta: "white",
      ordiniTrasmessi: [],
    },
    {
      nomeRiquadro: "MANCA ETICHETTA",
      nomeStato: "MANCA ETICHETTA",
      coloreRiquadro: "light-red",
      coloreScritta: "black",
      ordiniTrasmessi: [],
    },
    {
      nomeRiquadro: "MAG ASSENTE",
      nomeStato: "MAGAZZINO ASSENTE",
      coloreRiquadro: "mid-gray",
      coloreScritta: "white",
      ordiniTrasmessi: [],
    },
    {
      nomeRiquadro: "ALTRA ATTESA",
      nomeStato: "ALTRA ATTESA",
      coloreRiquadro: "light-green",
      coloreScritta: "black",
      ordiniTrasmessi: [],
    },
    {
      nomeRiquadro: "RESO CONFORME",
      nomeStato: "RESO CONFORME",
      coloreRiquadro: "dark-green",
      coloreScritta: "white",
      ordiniTrasmessi: [],
    },
  ]);

  const [input, setInput] = useState("");
  const [statoSelezionato, setStatoSelezionato] = useState("PRONTO PER BRT");
  const [arrayOrdiniSparatiMisti, setArrayOrdiniSparatiMisti] = useState([]);

  const suonoConferma = new Audio(beep);
  const suonoErrore = new Audio(errorSound);

  const handleInput = async function (evt) {
    const value = evt.target.value;

    try {
      setInput(value);
    } catch (err) {
      console.log("Errore nel cambio dello stato input: " + err);
      throw err;
    }
  };

  const cambiaStato = function (statoRiquadro) {
    setStatoSelezionato(statoRiquadro);
  };

  const barcodeToOrder = function (barcode) {
    return parseInt(barcode.slice(-6));
  };

  const handleKeyDown = async function (event) {
    //console.log(event.key);

    if (event.key === "Enter") {
      event.preventDefault();
      // GLI ALERT DEVONO BLOCCARE L'INSERIMENTO IN DB O NO?
      try {
        const ordineDaTrasmettere = barcodeToOrder(input);
        try {
          //console.log("invio il codice al server")
          const data = {
            ordine: ordineDaTrasmettere,
            stato: statoSelezionato,
            mag: "Prato Nevoso",
          };
          const dataToSend = JSON.stringify(data);
          let request = new XMLHttpRequest();
          request.open(
            "PATCH",
            apiUrl + "/logistica/sparaOrdini/changeOrderState",
            true
          );
          request.setRequestHeader("Content-Type", "application/json");
          request.send(dataToSend);
        } catch (err) {
          console.log("Errore nell'invio del prodotto alle API': " + err);
          throw err;
        }
        try {
          //console.log("provo ad aggiungere l'ordine all'array")
          setStati((statiCorrenti) =>
            statiCorrenti.map((stato) => {
              //console.log("nomeStato: ",stato.nomeStato,"statoSelezionato: ",statoSelezionato);
              if (stato.nomeStato === statoSelezionato) {
                return {
                  ...stato,
                  ordiniTrasmessi: [
                    ...stato.ordiniTrasmessi,
                    ordineDaTrasmettere,
                  ],
                };
              }

              return {
                ...stato,
                ordiniTrasmessi: stato.ordiniTrasmessi.filter(function (
                  value
                ) {
                  return value !== ordineDaTrasmettere;
                }),
              };
            })
          );
        } catch (err) {
          console.log(
            "Errore nell'aggiunta dell'ordine all'array del corriere: " + err
          );
          throw err;
        }
        try {
          setArrayOrdiniSparatiMisti((ordiniCorrenti) => [
            ...ordiniCorrenti,
            ordineDaTrasmettere,
          ]);
        } catch (err) {
          console.log(
            "Errore nell'aggiunta dell'ordine all'array mista: " + err
          );
          throw err;
        }
        // REQUISITI PER FARE IL SUONO DA AGGIORNARE
        if (
          parseInt(ordineDaTrasmettere) > 100000 &&
          parseInt(ordineDaTrasmettere) < 900000
        ) {
          suonoConferma.play();
        } else {
          suonoErrore.play();
        }
        setInput("");
      } catch (err) {
        console.log("Errore nella gestione del tasto invio: " + err);
        throw err;
      }
    }
  };

  return (
    <div className="areaComposizione fr">
      <div className="areaComposizione colonnaTuttaPagina sfondoBiancoTema br4 br--bottom shadow-4 pa2">
        <div className="center tc">
          <h2>MODALITÀ ONLINE</h2>
          <h3>Assicurati che il cursore lampeggi e spara il barcode</h3>
          <input
            autoFocus
            type="text"
            id="input"
            name="input"
            value={input}
            autoComplete="off"
            onChange={handleInput}
            className={inputClassesConTasto}
            onKeyDown={handleKeyDown}
          />
          {/* <button onClick={(e)=>{}} className={classiTastoSblocco}>INVIA</button> */}
          <h3 className="center tc">
            {"All'ordine sarà associato lo stato selezionato: " +
              statoSelezionato}
          </h3>
        </div>
        <div className="flex flex-wrap justify-center">
          {stati.map((stato) => {
            const conteggioOrdini = stato.ordiniTrasmessi.reduce(
              (conteggio, ordine) => ({
                ...conteggio,
                [ordine]: (conteggio[ordine] || 0) + 1,
              }),
              {}
            );
            const arrDuplicati = Object.entries(conteggioOrdini).filter(
              ([, numeroScansioni]) => numeroScansioni > 1
            );

            return (
              <RiquadroStatoBeta
                key={stato.nomeRiquadro}
                ordiniInArray={stato.ordiniTrasmessi.length}
                arrDuplicati={arrDuplicati}
                nomeRiquadro={stato.nomeRiquadro}
                nomeStato={stato.nomeStato}
                coloreRiquadro={stato.coloreRiquadro}
                coloreScritta={stato.coloreScritta}
                ordiniTrasmessi={stato.ordiniTrasmessi}
                statoSelezionato={statoSelezionato}
                cambiaStato={cambiaStato}
              />
            );
          })}
        </div>
        <div className="ultimiOrdiniTrasmessiMobile">
          <StatiTrasmessiTutti array={arrayOrdiniSparatiMisti} />
        </div>
      </div>
    </div>
  );
}

export default AreaLogisticaBeta;
